<template>
  <div :class="[`${prefixCls}-link`, {[`${prefixCls}-link-active`]: active}]">
    <!-- change a to div -->
    <div
      :class="[`${prefixCls}-link-title`, {[`${prefixCls}-link-title-active`]: active}]"
      :href="href"
      :title="title"
      @click="handleClick"
    >{{title}}</div>
    <slot></slot>
  </div>
  <!--
    ignore: prefixCls, href
    
    {$slots.default}

    title -> String
  -->
</template>

<script>
export default {
  name: "AnchorLink",
  props: {
    prefixCls: {
      type: String,
      default: "ant-anchor"
    },
    href: {
      type: String,
      default: "#"
    },
    title: {
      type: String,
      defaault: ""
    }
  },
  data() {
    this.links = [];
    return {
      activeLink: null
    };
  },
  computed: {
    active() {
      return this.antAnchor.$data.activeLink === this.href;
    }
  },
  inject: {
    antAnchor: { default: () => ({}) },
    antAnchorContext: { default: () => ({}) }
  },
  watch: {
    href(val, oldVal) {
      this.antAnchor.unregisterLink(oldVal);
      this.antAnchor.registerLink(val);
    }
  },
  methods: {
    handleClick(e) {
      this.antAnchor.scrollTo(this.href);
      const { scrollTo } = this.antAnchor;
      const { href, title } = this.$props;
      if (this.antAnchorContext.$emit) {
        this.antAnchorContext.$emit("click", e, { title, href });
      }
      scrollTo(href);
    }
  },

  mounted() {
    this.antAnchor.registerLink(this.href);
  },

  beforeDestroy() {
    this.antAnchor.unregisterLink(this.href);
  }
};
</script>

<style lang="scss" scoped>
$note-color: #f2f2f2;
$text-active-color: #0081ff;

.ant-anchor-link {
  .ant-anchor-link {
    padding-left: 8px;
  }
}
.ant-anchor-link-title {
  box-sizing: border-box;
  margin-bottom: 20px;
  border-left: solid 3px $note-color;
  padding-left: 8px;
  transition-property: color, border-color;
  transition-duration: 0.2s;
  transition-timing-function: ease-out;
}
.ant-anchor-link-title-active {
  color: $text-active-color;
}
</style>


// WEBPACK FOOTER //
// src/views/privacyCloud/components/anchorLink.vue